import React from "react";
import { useTranslation } from "react-i18next";
import emptyBanner from "../../images/empty_banner.jpeg";

// Result rows shared by SearchBar (desktop) and MobileSearch.
// Desktop keeps its original classes (light mode remaps them like any panel).
// `inverted` (mobile) uses the opposite of the app theme: light on dark, dark on
// light. The dark one uses kk-dark-section + #1E0039, the pair tailwind.css
// exempts from the light-mode remap (same as the EpkCard menu).
const PALETTES = {
  desktop: { box: "tw-bg-[#1C0039] tw-shadow-black/60", row: "tw-text-white hover:tw-bg-[#712CB0]/20" },
  dark: { box: "kk-dark-section tw-bg-[#1E0039] tw-shadow-black/60", row: "tw-text-white hover:tw-bg-white/10" },
  light: { box: "tw-bg-white tw-shadow-black/20", row: "tw-text-[#1C0039] hover:tw-bg-[#712CB0]/10" },
};

export default function SearchResults({ results, onSelect, inverted, isLight, className = "" }) {
  const { t } = useTranslation();

  const palette = PALETTES[!inverted ? "desktop" : isLight ? "dark" : "light"];

  return (
    <div className={`tw-absolute tw-top-full tw-mt-2 tw-overflow-auto tw-rounded-2xl tw-border tw-border-[#712CB0]/30 tw-shadow-2xl tw-z-[9999] ${palette.box} ${className}`}>
      {results.map((item) => {
        const thumb = item.image_details
          ? item.image_details.startsWith("https")
            ? item.image_details
            : `${process.env.REACT_APP_AWS_URL}/${item.image_details}`
          : item.picture
          ? item.picture.startsWith("https")
            ? item.picture
            : `${process.env.REACT_APP_AWS_URL}/${item.picture}`
          : emptyBanner;

        return (
          <a
            key={item._id}
            href={item.title ? `/epk/${item._id}` : `/user/${item._id}`}
            onClick={onSelect}
            className={`tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-no-underline tw-transition-colors tw-border-b tw-border-[#712CB0]/10 last:tw-border-0 ${palette.row}`}
          >
            <img
              src={thumb}
              alt=""
              className="tw-h-9 tw-w-9 tw-rounded-lg tw-object-cover tw-flex-shrink-0"
            />
            <div className="tw-min-w-0 tw-flex-1">
              <p className="tw-truncate tw-text-sm tw-font-medium tw-m-0">
                {item.title || `${item.firstName} ${item.lastName}`}
              </p>
              {item.role && (
                <p className="tw-text-[11px] tw-text-[#712CB0] tw-m-0 tw-capitalize">
                  {t(item.role)}
                </p>
              )}
            </div>
          </a>
        );
      })}
    </div>
  );
}
